module.exports = __webpack_public_path__ + "static/media/sign-icon.1b2af5a6.svg";